import { render } from "./Spinner.vue?vue&type=template&id=6f32fa3a&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=6f32fa3a&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./Spinner.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f32fa3a"]])

export default __exports__